<div [ngClass]="[position, colour, 'corner-ribbon']" [title]="hoverText">{{ text }}</div>
